import { TrialResult } from "interface/trial"
import {
  Stack, Box, Alert,
  List, ListItem, ListItemProps, ListItemButton, 
  Typography
} from "@mui/material"
import { dateFormat } from 'shared/util'

type TrialListRecordProps = {
  trial: TrialResult
  onSelChangeTrial: (trial: TrialResult) => void
} & ListItemProps
export const TrialListRecord = ({
  trial,
  onSelChangeTrial,
  ...others
}: TrialListRecordProps) => {
  return (
    <ListItem disablePadding {...others}>
      <ListItemButton
        onClick={() => onSelChangeTrial(trial)}
        sx={{
          padding: 1,
          borderBottom: 1,
          borderColor: 'divider'
        }}
      >
        <Stack direction='column' spacing={1} width='100%'>
          <Typography variant='body1' color='text.primary' component='div'>{trial.title}</Typography>
          <Stack direction='row' spacing={2} justifyContent='flex-end'>
            {trial.registrationDate ? (
              <Stack direction='row' spacing={1} alignItems='baseline' flexWrap="wrap">
                <Typography variant='caption' color='text.secondary' component='span'>登録</Typography>
                <Typography variant='body2' color='text.secondary' component='span'>{dateFormat(trial.registrationDate, { nullText: '--' })}</Typography>
              </Stack>
            ) : <></> }
            {trial.firstPublicDate ? (
              <Stack direction='row' spacing={1} alignItems='baseline' flexWrap="wrap">
                <Typography variant='caption' color='text.secondary' component='span'>公開</Typography>
                <Typography variant='body2' color='text.secondary' component='span'>{dateFormat(trial.firstPublicDate, { nullText: '--' })}</Typography>
              </Stack>
            ) : <></> }
          </Stack>
        </Stack>
      </ListItemButton>
    </ListItem>
  )
}

type TrialListProps = {
  trials: TrialResult[]
  onSelChangeTrial: (trialId: number) => void
}
export const TrialList = ({
  trials,
  onSelChangeTrial
}: TrialListProps) => {
  return trials.length === 0 ? (
    <Box padding={1}><Alert severity="info">対象が見つかりません.</Alert></Box>
  ) : (
    <List disablePadding>
      {trials.map(record =>
        <TrialListRecord
          key={record.trialId}
          trial={record}
          onSelChangeTrial={trial => onSelChangeTrial(trial.trialId)} />
      ) }
    </List>
  )
}

